import axios from './interceptor';

export const AddressesService = {

  getAddresses(is_virtual) {
    const url = 'api/users/addresses';
    const envelope = {
      method: 'get',
      url: url
    }
    if (is_virtual != undefined) {
      envelope.params = { is_virtual }
    }
    return axios(envelope);
  },
  createAddress(payload){
    const url = 'api/users/addresses';
    return axios({
      method: 'post',
      url: url,
      data: payload
    })
  },
  updateAddress(payload){
    const url = 'api/users/addresses/'+ payload.id;
    return axios({
      method: 'put',
      url: url,
      data: payload
    })
  },
  deleteAddress(payload){
    const url = 'api/users/addresses/' + payload.id;
    return axios({
      method: 'delete',
      url: url
    })
  }
};